import React, { Dispatch, SetStateAction } from 'react';

import ModalWindow from '@ui-lib/components/ModalWindow';

import CameraPreview from '../../../pages/BolCreatePage/components/Step2/CameraPreview';

interface AddPhotoModalProps {
  open: boolean;
  onClose: () => void;
  onCapture: (imageSrc: string) => void;
  cameraError: string | null;
  setCameraError: Dispatch<SetStateAction<string | null>>;
}

const AddPhotoModal = ({
  open,
  onClose,
  onCapture,
  cameraError,
  setCameraError,
}: AddPhotoModalProps) => {
  return (
    <ModalWindow testID='modal-window' open={open} onClose={onClose}>
      <CameraPreview
        onClose={onClose}
        onCapture={onCapture}
        cameraError={cameraError}
        setCameraError={setCameraError}
      />
    </ModalWindow>
  );
};

export default AddPhotoModal;
